import classNames from 'classnames';
import React from 'react';

type Props = {
	text: string;
	max: number;
	min?: number;
};

export default function CharacterCount({
	text,
	max,
	min = text.length - 1,
}: Props) {
	if (text === null) return null;
	const count = text.length;
	return (
		<p
			className={classNames('text-sm font-light mb-1 ml-2 italic', {
				'text-red-900': count <= min || count > max,
			})}
		>
			{count}/{max}
		</p>
	);
}
